// components/ErrorPage.js
import React from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import IconError from '../../assets/illustration/error/505.svg'

const ErrorPage = () => {
    const location = useLocation();

    // //   // Verifica se l'accesso alla pagina è stato fatto tramite redirect
      if (!location.state || !location.state.errorTriggered) {
        return <Navigate to="/" />; // Reindirizza alla home se l'accesso è manuale
      }

    return (
        <div className="flex flex-col items-center justify-center my-32 text-center">
            <img src={IconError} alt="404 Error" className="w-3/4 h-auto mb-12" />
            <p className="text-2xl  text-burnt-coffee font-heading uppercase font-semibold mb-12">QUALCOSA NON FUNZIONA. IL NOSTRO TEAM è STATO AVVISATO<br></br>
                E STA LAVORANDO PER RISOLVERE IL PROBLEMA.</p>
         
        </div>
    );
};

export default ErrorPage;
